export default __webpack_public_path__ + "images/AI.3dd711c.png";